import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { LIVE_LINK } from '../helpers/url_helper';
export const priorityUkApi = createApi({
  reducerPath: 'priorityUkApi',
  baseQuery: fetchBaseQuery({ baseUrl: `${LIVE_LINK}/priority` }),
  tagTypes: ['priorityUk'],
  refetchOnFocus: true,
  endpoints: (build) => ({
    fetchAllPriorityUk: build.query({
      query: () => ({
        url: '/priority-ukraine'
      }),
      providesTags: (result) =>
        result?.priorityUk ? [...result.priorityUk.map(({ _id }) => ({ type: 'priorityUk', id: _id })), { type: 'priorityUk', id: 'LIST' }] : [{ type: 'priorityUk', id: 'LIST' }]
    }),
    addPriorityUk: build.mutation({
      query: (newRow) => ({
        url: '/priority-ukraine',
        method: 'POST',
        body: newRow
      }),
      async onQueryStarted(newRow, { dispatch, queryFulfilled }) {
        const patchResult = dispatch(
          priorityUkApi.util.updateQueryData('fetchAllPriorityUk', undefined, (draft) => {
            draft.priorityUk.push(newRow); // Optimistically add the new row to the list
          })
        );

        try {
          await queryFulfilled;
        } catch {
          patchResult.undo(); // Revert optimistic addition on failure
        }
      },
      invalidatesTags: [{ type: 'priorityUk', id: 'LIST' }]
    }),
    updatePriorityUk: build.mutation({
      query: (updatedRow) => ({
        url: `priority-ukraine/${updatedRow._id}`,
        method: 'PUT',
        body: updatedRow
      }),
      async onQueryStarted(updatedRow, { dispatch, queryFulfilled }) {
        const patchResult = dispatch(
          priorityUkApi.util.updateQueryData('fetchAllPriorityUk', undefined, (draft) => {
            const item = draft.priorityUk.find((row) => row._id === updatedRow._id);
            if (item) {
              Object.assign(item, updatedRow); // Apply changes optimistically
            }
          })
        );

        try {
          await queryFulfilled;
        } catch {
          patchResult.undo(); // Revert optimistic update on failure
        }
      },
      invalidatesTags: (result, error, updatedRow) => {
        return [
          { type: 'priorityUk', id: updatedRow._id },
          { type: 'priorityUk', id: 'LIST' }
        ];
      }
    }),
    deletePriorityUk: build.mutation({
      query: (id) => ({
        url: `priority-ukraine/${id}`,
        method: 'DELETE'
      }),
      async onQueryStarted(id, { dispatch, queryFulfilled }) {
        const patchResult = dispatch(
          priorityUkApi.util.updateQueryData('fetchAllPriorityUk', undefined, (draft) => {
            const index = draft.priorityUk.findIndex((row) => row._id === id);
            if (index !== -1) {
              draft.priorityUk.splice(index, 1); // Remove item optimistically
            }
          })
        );

        try {
          await queryFulfilled;
        } catch {
          patchResult.undo(); // Revert optimistic deletion on failure
        }
      },
      invalidatesTags: (result, error, id) => [
        { type: 'priorityUk', id },
        { type: 'priorityUk', id: 'LIST' }
      ]
    })
  })
});
